/*
 This object contains the objects of the Cabri3D instance.
 This module and object can be used as a mock-object within unit-testing.
 */
import gestureHandler from "./gestures";


const cabri = {};

cabri.allObjects = [];
cabri.objects = [];
cabri.gestureHandler = gestureHandler;
cabri.highlightedPoints = [];

export default cabri;